import { ReactComponent as IconMegaphone } from "assets/images/icons/bxs-megaphone.svg";
import BackBar from "components/ui/BackBar/BackBar";
import ContentContainer from "layout/Content/ContentContainer";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import ViewBulletins from "features/bulletins/components/ViewBulletins";
import ViewContextProvider from "features/view/context/ViewContext";
import Sort from "features/view/components/Sort/Sort";
import BulletinCreateButton from "features/bulletins/components/BulletinCreateButton";
import useEntity from "hooks/useEntity";

function BulletinBoardPersonal() {
  const { entity } = useEntity(window.location.pathname, 'page');

  const sortOptions = [
    {
      id: 'created|DESC',
      value: 'Meest recent eerst',
    },
    {
      id: 'created|ASC',
      value: 'Minst recent eerst',
    },
    {
      id: 'title|ASC',
      value: 'Alfabetisch (oplopend)',
    },
    {
      id: 'title|DESC',
      value: 'Alfabetisch (aflopend)',
    },
  ];

  return (
    <>
      <BackBar path={ `/startpagina` } label={ 'Naar mijn startpagina' }/>

      <ContentContainer contentGridType={ 'wide' } contentPadding={ true } contentBackground={ true }>
        <div className={ 'content__header' }>
          <div>
            <TitleWithIcon title={ 'Mijn prikbord' } hasBottomMargin={ true }>
              <IconMegaphone/>
            </TitleWithIcon>
            <p>
              Hier kunt u uw berichten bekijken, bewerken en verwijderen.
            </p>
          </div>

          <div className={ 'content__header-right' }>
            {
              entity?.field_bulletin_category?.id &&
                <BulletinCreateButton category={ `bulletin` } categoryId={ entity.field_bulletin_category.id }/>
            }
            <Sort options={ sortOptions } variant={ 'transparent-primary' }/>
          </div>
        </div>

        <div className={ 'teasers-container--1col' }>
          <ViewContextProvider name={ 'my-bulletin' }>
            <ViewBulletins layoutPersonal={ true }/>
          </ViewContextProvider>
        </div>
      </ContentContainer>
    </>
  );
}

export default BulletinBoardPersonal;
